module.exports = __webpack_public_path__ + "static/media/daedong-story-02.2db479a4.jpg";